import * as React from "react";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";

const PricingFeature = ({ icon, text }: { icon: SemanticICONS; text: string }) => {
	return (
		<li className={"Pricing--feature  margin-2-y"}>
			<div className={"Pricing--feature-icon padding-1-all"}>
				<Icon
					name={icon}
					size={"large"}
					color={"grey"}
				/>
			</div>
			<p> {text} </p>
		</li>
	);
};

export default PricingFeature;
